import { generatePath, Redirect, Route, RouteProps } from "react-router";
import { useAppSelector } from "../app/hooks";
import { appPath, paramName } from "./AppRoute";

export const SentRoute = (props: RouteProps) => {

  const answer = useAppSelector((state) => {
    return state.inputAnswer.answer;
  })

  if (answer.status !== 'fulfilled') {
    const inputPath = generatePath(
      appPath.shopqr.inputAnswer,
      {
        [paramName.surveyQestionPageIndexStr]: 0,
      }
    )
    return <Redirect to={inputPath} />
  }
  
  return <Route {...props} />
}
